import script from "./DashboardHeadMarketing.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardHeadMarketing.vue?vue&type=script&setup=true&lang=js"

import "./DashboardHeadMarketing.vue?vue&type=style&index=0&id=331036c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-331036c9"]])

export default __exports__